// ============================================================================
// MarketRatingBadge — единая подпись рейтинга мастера (звёзды + средняя +
// количество отзывов). Значения приходят С СЕРВЕРА (только опубликованные
// отзывы): ничего не досчитываем и не показываем «0.0», если данных нет.
// ============================================================================

import { Star } from 'lucide-react';

interface MarketRatingBadgeProps {
  rating: number | null;
  count: number | null;
  /** Компактный вид (в строке карточки): только звезда, оценка и число. */
  compact?: boolean;
  className?: string;
}

function ratingText(rating: number): string {
  return Number.isInteger(rating) ? String(rating) : rating.toFixed(1);
}

export function MarketRatingBadge({
  rating,
  count,
  compact = false,
  className = '',
}: MarketRatingBadgeProps) {
  // Нет отзывов — честно «Нет отзывов» (рейтинг не выдумываем).
  if (rating === null || count === null || count <= 0) {
    return (
      <span
        className={`inline-flex items-center gap-1 text-[11px] text-muted-foreground ${className}`}
        title="Опубликованных отзывов пока нет"
      >
        <Star className="h-3 w-3" />
        Нет отзывов
      </span>
    );
  }
  const label = compact
    ? `${ratingText(rating)} · ${count}`
    : `${ratingText(rating)} · ${count} ${count === 1 ? 'отзыв' : count < 5 ? 'отзыва' : 'отзывов'}`;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border border-amber-500/30 bg-amber-500/10 px-2 py-0.5 text-[11px] font-medium text-amber-700 ${className}`}
      title={`Средняя оценка ${ratingText(rating)} из 5 по ${count} опубликованным отзывам`}
    >
      <Star className="h-3 w-3 fill-amber-400 text-amber-400" />
      {label}
    </span>
  );
}
